// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1e73de02","453":"83d53db1"}[chunkId] + ".chunk.js";
};